module.exports = __webpack_public_path__ + "img/editor.838b9d2a.svg";